<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="800px"
      scrollable
      @keydown="executeCloseModalFilesSupplier"
      @click:outside="executeCloseModalFilesSupplier"
    >
      <v-card>
        <div class="p-4 pb-0" v-if="currentSupplier">
          <h5>
            Archivos del Proveedor: <b>{{ currentSupplier.official_name }}</b>
          </h5>
        </div>
        <hr />
        <v-card-text>
          <managment-documents-supplier
            :onlyShow="true"
            ref="managmentDocumentsSupplier"
            :currentSuplier="currentSupplier"
          ></managment-documents-supplier>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalFilesSupplier"
          >
            <small>
              Cerrar
            </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { STATUS_SUPPLIER } from "@/constants/supplier";
import { authUsuarioComputed } from "@/state/helpers";
import swal2 from "sweetalert2";
import ManagmentDocumentsSupplier from "./ManagmentDocumentsSupplier.vue";
export default {
  components: { ManagmentDocumentsSupplier },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalFilesSupplier: {
      type: Function,
      default: () => {},
    },
    currentSupplier: {
      default: null,
    },
    showDeleteFileAndUpload: {
      default: false,
    },
  },
  data() {
    return {
      statusSupplier: STATUS_SUPPLIER,
      loading: false,
    };
  },
  methods: {
    executeCloseModalFilesSupplier($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.$refs.managmentDocumentsSupplier.resetForm();
        this.closeModalFilesSupplier($event);
      }
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
  watch: {
    currentSupplier(newValue) {
      if (newValue) {
        let self = this;
        setTimeout(() => {
          self.$refs.managmentDocumentsSupplier.setDocumentsFromSupplier(
            newValue
          );
        }, 100);
      }
    },
  },
};
</script>

<style></style>
